<template>
    <div class="products_services_container" id="products_services">
		<div class="products_services_main">
			<div class="products_services_title">{{ $t('index.products_services_title') }}</div>
			<div class="products_services_desc">{{ $t('index.products_services_desc') }}</div>
			<div class="products_services_item_box">
				<div 
					class="products_services_item" 
					v-for="(item, i) in blocks" :key="i" 
					:style="backgroundImageStyle(i)">
					<p>{{ $t('index.products_services_item_title_' + i) }}</p>
					<p>{{ $t('index.products_services_item_desc_' + i) }}</p>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
export default {
    name: 'ProductsServicesMobile',
    data() {
        return {
            tips  : 'Hello World',
            blocks: 6
        }
    },

    methods: {
        // 动态添加背景图
        backgroundImageStyle(i)
		{
			const imageUrl = require(`@/assets/static/imgs/home/m/icon-proservices-${i}.png`);
			return {
				'background-image'   : `url(${imageUrl})`,// 使用 require 导入图片路径
				// 'background-position': '387px center',    // 设置背景图片位置
				'background-repeat'  : 'no-repeat',       // 设置背景图片是否重复
				// 'background-size' : '212px 202px',     // 设置背景图片填充方式
			};
		}
    }
}
</script>

<style lang="less" scoped>
.products_services_container{
	display:flex;justify-content:center;align-items:flex-start;
	width:var(--com-base-container-wm);height:auto;
	background:linear-gradient(135deg, rgba(63, 11, 157, 1), rgba(19, 21, 77, 1), rgb(15, 17, 66), rgba(30, 4, 78, 1));
	padding-bottom:30px;
	.products_services_main{
		margin:0 auto;padding-top:75px;
		width:var(--com-base-content-wm);height:inherit;
		/* background:#CCC; */
		.products_services_title{
			height:50px;line-height:50px;
			font-size:var(--com-base-fz-58);font-weight:bold;color:#FFF;text-align:center;
		}
		.products_services_desc{
			height:80px;line-height:80px;
			font-size:var(--com-base-fz-28);font-weight:normal;color:#7D7EA8;text-align:center;
		}
		.products_services_item_box{
			margin:0 auto;margin-top:30px;
			width:var(--com-base-content-wm);height:auto;
			display:flex;flex-direction:column;justify-content:flex-start;align-items:center;
			.products_services_item{
				width:var(--com-base-content-wm);height:226px;
				border:2px solid rgba(255, 255, 255, .1);border-radius:24px;
				margin-bottom:20px;
				padding:18px;
				background-position:right bottom;
				background-size:206px 206px;
				p:nth-child(1){
					font-family:var(--com-number-coin-fm-M);font-size:var(--com-base-fz-28);color:#FFF;
				}
				p:nth-child(2){
					font-family:var(--com-number-coin-fm-L);font-size:var(--com-base-fz-24);font-weight:normal;color:#B1B7E7;
					line-height:1.5;
					margin-top:3px;
				}
			}
		}
	}
}
</style>